import DateFormat from "sap/ui/core/format/DateFormat";
import NumberFormat from "sap/ui/core/format/NumberFormat";

// TBD: I don't know why, but I couldn't just format it in XML like in other UI5 applications: "{path: '...', type: 'sap.ui.model.type.Date', formatOptions: { style: 'medium' } }".
// TBD: An error happens because date is a string, IDK if there's a way to fix it with format options.
// NOTE: idk if there is a special case, in which format the date comes to frontend but ms should be included in the pattern
// NOTE: "{ path: '...', type: 'sap.ui.model.type.Date', formatOptions: {style: 'medium', source: {pattern: 'yyyy-MM-ddTHH:mm:SS.sssssssZ'}} }"
export function FormatDateTime(dateStr?: string | null) {
  if (!dateStr) return "";

  const oDate = DateFormat.getDateTimeInstance({
    style: "medium",
  });
  return oDate.format(new Date(dateStr));
}

export function FormatDate(dateStr?: string | null) {
  if (!dateStr) return "";

  const oDate = DateFormat.getDateInstance({
    style: "medium",
  });
  return oDate.format(new Date(dateStr));
}

export function FormatPrice(
  price?: number | null | string,
  includeCurrency = true
) {
  if (!price && price !== 0) return "";

  const oFormat = NumberFormat.getCurrencyInstance({
    currencyCode: true,
    decimals: 2,
    style: "standard",
    trailingCurrencyCode: true,
  });
  const oPrice = oFormat.format(price, includeCurrency ? "\u20AC" : ""); // Euro sign
  return oPrice;
}

/** Returns string like "yyyy-MM-dd", which is what .NET accepts as DateOnly. */
export function GetDateOnlyString(date?: Date): string | undefined {
  // A bit of a hack - Swedish date format is "yyyy-MM-dd", which is what we want
  // Important to use the locale function instead of toISOString, because toISOString converts the date to UTC, which can result in a differnt day.
  return date && date.toLocaleDateString("sv");
}

export function GetTranslationKeyForBoolean(value?: boolean) {
  return value === true ? "yes" : value === false ? "no" : "";
}

export function FormatFileSize(size?: number) {
  if (!size) return "0 B"

  const units = ["B", "KB", "MB", "GB"];
  const k = 1000;

  const unitIndex = Math.min(
    units.length - 1,
    Math.floor(Math.log(size) / Math.log(k))
  );

  const value = parseFloat((size / (k ** unitIndex)).toFixed(2));
  return `${value} ${units[unitIndex]}`;
}

export function FormatMimeType(mimeType?: string) {
  if (!mimeType) return "";

  return mimeType.split("/")[1].toUpperCase();
}

export function FormatAttachmentInfo(size: number, mimeType: string) {
  return FormatFileSize(size) + " • " + FormatMimeType(mimeType);
}

